


















































import {Component, Prop, Vue} from "vue-property-decorator";
import firebase from "firebase";
import {mapGetters} from "vuex";

@Component({
    components: {},
    computed: {...mapGetters(["user"])},
})
export default class ChangePwd extends Vue {
    user!: any;
    email = '';
    isEmailErr = false;

    async sendEmail() {

        if (this.email === this.user.email) {
            try {
                const result = await firebase
                    .auth()
                    .sendPasswordResetEmail(this.email);
                this.$modal.show('checkMailModal')
            }
            catch {
                // this.submitError = true;
            }
        }
        else {
            this.isEmailErr = true;
        }
    }

}
